import React from 'react';

export const LinkedIn = ({ fillColor, className }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    className={className}
    strokeLinejoin='round'
    strokeLinecap='round'
    strokeWidth='2'
    stroke={fillColor}
    fill='none'
    viewBox='0 0 32 32'
  >
    <g>
      <title>Layer 1</title>
      <g id='svg_4'>
        <path
          id='svg_1'
          d='m20,12.5a6,6 0 0 1 6,6l0,7l-4,0l0,-7a2,2 0 0 0 -2,-2a2,2 0 0 0 -2,2l0,7l-4,0l0,-7a6,6 0 0 1 6,-6z'
        />
        <rect id='svg_2' height='12' width='4' y='13.5' x='6' />
        <circle id='svg_3' r='2' cy='8.5' cx='8' />
      </g>
      <rect
        strokeWidth='4'
        id='svg_5'
        height='32'
        width='32'
        y='-0.20704'
        x='0'
      />
    </g>
  </svg>
);
